import {Wrapper, Title, ListWrapper, CardWrapper} from './styles'

interface IWhyRent {
    title: string[];
    items: ICard[];
    reverseColor?: boolean;
}

interface ICard {
    title: string;
    text: string;
    src?: string | JSX.Element;
}

const Card: React.FC<ICard> = ({title, text, src}) => {
    return (
        <CardWrapper>
            {
                typeof src === "string" ?  <img src={src} width={140}/> : src
            }
            <div id='bold'>
                {title}
            </div>
            <p>
                {text}
            </p>
        </CardWrapper>
    )
}

export const ThreeBlocksSection: React.FC<IWhyRent> = ({title, items, reverseColor = false}) => {
    return (
        <Wrapper>
            <div>
                {reverseColor ? (
                    <Title>
                        <span>{title[0]}</span>{' '}{title[1]}
                    </Title>
                ) : (
                    <Title>
                        {title[0]}{' '}<span>{title[1]}</span>
                    </Title>
                )}
                <ListWrapper>
                    {
                        items.map((item) => <Card {...item}/>)
                    }
                </ListWrapper>
            </div>
        </Wrapper>
    )
}
